import { AsideComponent } from '@qima-labs/app/pages/main/shared/components/aside/aside.component';
import { AsideService } from '@qima-labs/app/pages/main/shared/components/aside/shared/services/aside.service';
import { HeaderComponent } from '@qima-labs/app/pages/main/shared/components/header/header.component';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsideComponent, HeaderComponent, RouterOutlet],
})
export class MainComponent implements OnInit {
  public isAsideCollapsed: boolean = false;

  public constructor(
    private readonly _asideService: AsideService,
    private readonly _changeDetectorRef: ChangeDetectorRef
  ) {}

  public ngOnInit(): void {
    this._watch();
  }

  private _watch(): void {
    this._asideService.isAsideCollapsed$.pipe(untilDestroyed(this)).subscribe((isAsideCollapsed: boolean): void => {
      this.isAsideCollapsed = isAsideCollapsed;
      this._changeDetectorRef.markForCheck();
    });
  }
}
